import type { ServiceRecordListQuery } from '@chukua/common';
import type { TableColumnsType } from 'antd';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { ServiceRecordView } from '../truck-service.api';

const number = new Intl.NumberFormat('en-KE');

/** Each column's `key` is its sort field in `serviceRecordListQuerySchema`; the type-of-service filter sits above the table. */
export function buildServiceRecordColumns({
  list,
}: {
  list: Pick<ListQueryControls<ServiceRecordListQuery>, 'sortOrderFor'>;
}): TableColumnsType<ServiceRecordView> {
  return [
    { title: 'Service', dataIndex: 'name', key: 'name', sorter: true, sortOrder: list.sortOrderFor('name') },
    {
      title: 'Date done',
      dataIndex: 'doneOn',
      key: 'doneOn',
      sorter: true,
      sortOrder: list.sortOrderFor('doneOn'),
      render: (value: string | null) => value ?? '—',
    },
    {
      title: 'Odometer',
      dataIndex: 'odometerKm',
      key: 'odometerKm',
      sorter: true,
      sortOrder: list.sortOrderFor('odometerKm'),
      render: (value: number | null) => (value == null ? '—' : `${number.format(value)} km`),
    },
    {
      title: 'Engine hours',
      dataIndex: 'engineHours',
      key: 'engineHours',
      render: (value: number | null) => (value == null ? '—' : `${number.format(value)} h`),
    },
    {
      title: 'Recorded',
      dataIndex: 'recordedAt',
      key: 'recordedAt',
      sorter: true,
      sortOrder: list.sortOrderFor('recordedAt'),
      render: (at: string) => at.slice(0, 10),
    },
  ];
}
